import React from 'react';

import SimpleField from './simple';

export default function PercentageDealField(props) {
  return <SimpleField {...props} type="percentage" />;
}
